export default "__VITE_ASSET__CWDLDxTS__"